<template>
  <v-row no-gutters align="center" justify="start">
    <v-col cols="auto"  v-if="!isNoData('formfactor')">
      <v-menu
        v-model="menuFormFactor"
        bottom
        right
        transition="scale-transition"
        origin="top left"
        offset-y
        :nudge-bottom="10"
        min-width="283"
        :close-on-content-click="true"
      >
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            color="#B3B3B3"
            :text-color="formFactorValue === ''? '#666666' : '#041E42'"
            outlined
            v-on="on"
            :style="formFactorValue === ''? {backgroundColor: '#FFFFFF !important'} : {backgroundColor: '#C7DCF0 !important'}"
          >
            {{formFactorValue ? formFactorValue : 'Form Factor'}}
            <v-icon text icon v-show="formFactorValue === ''" class="pl-3">arrow_drop_down</v-icon>
            <v-icon text icon @click.stop="clearFilter('formfactor')" v-show="formFactorValue !== ''" class="pl-3">
              close
            </v-icon>
          </v-chip>
        </template>
        <v-card>
          <v-list class="pt-0 pb-0">
            <v-list-item class="pl-5 pr-2">
              <v-list-item-content class="pt-0 pb-0" style="margin-top: -8px;">
                <v-list-item-title><span style="font-weight: bold;">Form Factor</span></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-1">
                <v-btn
                  icon
                  @click="menuClose('formfactor')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0 pb-0" style="margin-top: -12px;">
            <v-list-item>
              <v-radio-group v-model="formFactorValue" :mandatory="false" class="mt-0">
                <v-radio
                  v-for="formFactor in deviceFormFactorSelectData"
                  :key="formFactor.value"
                  :label="`${formFactor.label}`"
                  :value="formFactor.value"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-col>

    <v-col cols="auto" v-if="!isNoData('model')">
      <v-menu
        v-model="menuModel"
        bottom
        right
        transition="scale-transition"
        origin="top left"
        offset-y
        :nudge-bottom="10"
        min-width="283"
        :close-on-content-click="true"
      >
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            color="#B3B3B3"
            :text-color="modelValue === ''? '#666666' : '#041E42'"
            outlined
            v-on="on"
            :style="modelValue === ''? {backgroundColor: '#FFFFFF !important'} : {backgroundColor: '#C7DCF0 !important'}"
          >
            {{modelValue ? modelValue : 'Model'}}
            <v-icon text icon v-show="modelValue === ''" class="pl-3">arrow_drop_down</v-icon>
            <v-icon text icon @click.stop="clearFilter('model')" v-show="modelValue !== ''" class="pl-3">
              close
            </v-icon>
          </v-chip>
        </template>
        <v-card>
          <v-list class="pt-0 pb-0">
            <v-list-item class="pl-5 pr-2">
              <v-list-item-content class="pt-0 pb-0" style="margin-top: -8px;">
                <v-list-item-title><span style="font-weight: bold;">Model</span></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-1">
                <v-btn
                  icon
                  @click="menuClose('model')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0 pb-0" style="margin-top: -12px;">
            <v-list-item>
              <v-radio-group v-model="modelValue" :mandatory="false" class="mt-0">
                <v-radio
                  v-for="device in deviceModelSelectData"
                  :key="device.value"
                  :label="`${device.label}`"
                  :value="device.value"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-col>

    <v-col cols="auto" v-if="!isNoData('age')">
      <v-menu
        v-model="menuAge"
        bottom
        right
        transition="scale-transition"
        origin="top left"
        offset-y
        :nudge-bottom="10"
        min-width="283"
        :close-on-content-click="true"
      >
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            color="#B3B3B3"
            :text-color="ageValue === ''? '#666666' : '#041E42'"
            outlined
            v-on="on"
            :style="ageValue === ''? {backgroundColor: '#FFFFFF !important'} : {backgroundColor: '#C7DCF0 !important'}"
          >
            {{ageValue ? getAgeLabel(ageValue) : 'Age'}}
            <v-icon text icon v-show="ageValue === ''" class="pl-3">arrow_drop_down</v-icon>
            <v-icon text icon @click.stop="clearFilter('age')" v-show="ageValue !== ''" class="pl-3">close</v-icon>
          </v-chip>
        </template>
        <v-card>
          <v-list class="pt-0 pb-0">
            <v-list-item class="pl-5 pr-2">
              <v-list-item-content class="pt-0 pb-0" style="margin-top: -8px;">
                <v-list-item-title><span style="font-weight: bold;">Age</span></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-1">
                <v-btn
                  icon
                  @click="menuClose('age')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0 pb-0" style="margin-top: -12px;">
            <v-list-item>
              <v-radio-group v-model="ageValue" :mandatory="false" class="mt-0">
                <v-radio
                  v-for="age in deviceAgeSelectData"
                  :key="age.value"
                  :label="`${age.label}`"
                  :value="age.value"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-col>

    <v-col cols="auto" v-if="!isNoData('utilisation')">
      <v-menu
        v-model="menuUsage"
        bottom
        right
        transition="scale-transition"
        origin="top left"
        offset-y
        :nudge-bottom="10"
        min-width="283"
        :close-on-content-click="true"
      >
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            color="#B3B3B3"
            :text-color="usageValue === ''? '#666666' : '#041E42'"
            outlined
            v-on="on"
            :style="usageValue === ''? {backgroundColor: '#FFFFFF !important'} : {backgroundColor: '#C7DCF0 !important'}"
          >
            {{usageValue ? getUtilisationLabel(usageValue) : 'Last Seen (Days Ago)'}}
            <v-icon text icon v-show="usageValue === ''" class="pl-3">arrow_drop_down</v-icon>
            <v-icon text icon @click.stop="clearFilter('utilisation')" v-show="usageValue !== ''" class="pl-3">
              close
            </v-icon>
          </v-chip>
        </template>
        <v-card>
          <v-list class="pt-0 pb-0">
            <v-list-item class="pl-5 pr-2">
              <v-list-item-content class="pt-0 pb-0" style="margin-top: -8px;">
                <v-list-item-title><span style="font-weight: bold;">Last Seen (Days Ago)</span></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-1">
                <v-btn
                  icon
                  @click="menuClose('utilisation')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0 pb-0" style="margin-top: -12px;">
            <v-list-item>
              <v-radio-group v-model="usageValue" :mandatory="false" class="mt-0">
                <v-radio
                  v-for="utilisation in deviceUtilisationSelectData"
                  :key="utilisation.value"
                  :label="`${utilisation.label}`"
                  :value="utilisation.value"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-col>

    <v-col cols="auto" v-if="!isNoData('warranty')">
      <v-menu
        v-model="menuWarranty"
        bottom
        right
        transition="scale-transition"
        origin="top left"
        offset-y
        :nudge-bottom="10"
        min-width="283"
        :close-on-content-click="true"
      >
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            color="#B3B3B3"
            :text-color="warrantyValue === ''? '#666666' : '#041E42'"
            outlined
            v-on="on"
            :style="warrantyValue === ''? {backgroundColor: '#FFFFFF !important'} : {backgroundColor: '#C7DCF0 !important'}"
          >
            {{warrantyValue ? getWarrantyLabel(warrantyValue) : 'Warranty'}}
            <v-icon text icon v-show="warrantyValue === ''" class="pl-3">arrow_drop_down</v-icon>
            <v-icon text icon @click.stop="clearFilter('warranty')" v-show="warrantyValue !== ''" class="pl-3">
              close
            </v-icon>
          </v-chip>
        </template>
        <v-card>
          <v-list class="pt-0 pb-0">
            <v-list-item class="pl-5 pr-2">
              <v-list-item-content class="pt-0 pb-0" style="margin-top: -8px;">
                <v-list-item-title><span style="font-weight: bold;">Warranty</span></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-1">
                <v-btn
                  icon
                  @click="menuClose('warranty')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0 pb-0" style="margin-top: -12px;">
            <v-list-item>
              <v-radio-group v-model="warrantyValue" :mandatory="false" class="mt-0">
                <v-radio
                  v-for="warranty in deviceWarrantySelectData"
                  :key="warranty.value"
                  :label="`${warranty.label}`"
                  :value="warranty.value"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-col>

    <v-col cols="auto" v-if="!isNoData('buildNumber')">
      <v-menu
        v-model="menuBuildNumber"
        bottom
        right
        transition="scale-transition"
        origin="top left"
        offset-y
        :nudge-bottom="10"
        min-width="283"
        :close-on-content-click="true"
      >
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            color="#B3B3B3"
            :text-color="buildNumberValue === ''? '#666666' : '#041E42'"
            outlined
            v-on="on"
            :style="buildNumberValue === ''? {backgroundColor: '#FFFFFF !important'} : {backgroundColor: '#C7DCF0 !important'}"
          >
            {{buildNumberValue ? buildNumberValue : 'Build Number'}}
            <v-icon text icon v-show="buildNumberValue === ''" class="pl-3">arrow_drop_down</v-icon>
            <v-icon text icon @click.stop="clearFilter('buildNumber')" v-show="buildNumberValue !== ''" class="pl-3">
              close
            </v-icon>
          </v-chip>
        </template>
        <v-card>
          <v-list class="pt-0 pb-0">
            <v-list-item class="pl-5 pr-2">
              <v-list-item-content class="pt-0 pb-0" style="margin-top: -8px;">
                <v-list-item-title><span style="font-weight: bold;">Build Number</span></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-1">
                <v-btn
                  icon
                  @click="menuClose('buildNumber')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0 pb-0" style="margin-top: -12px;">
            <v-list-item>
              <v-radio-group v-model="buildNumberValue" :mandatory="false" class="mt-0">
                <v-radio
                  v-for="device in deviceBuildNumberSelectData"
                  :key="device.value"
                  :label="`${device.label}`"
                  :value="device.value"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-col>

    <v-col cols="auto" v-if="!isNoData('operatingSystem')">
      <v-menu
        v-model="menuOperatingSystem"
        bottom
        right
        transition="scale-transition"
        origin="top left"
        offset-y
        :nudge-bottom="10"
        min-width="283"
        :close-on-content-click="true"
      >
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            color="#B3B3B3"
            :text-color="operatingSystemValue === ''? '#666666' : '#041E42'"
            outlined
            v-on="on"
            :style="operatingSystemValue === ''? {backgroundColor: '#FFFFFF !important'} : {backgroundColor: '#C7DCF0 !important'}"
          >
            {{operatingSystemValue ? operatingSystemValue : 'Operating System'}}
            <v-icon text icon v-show="operatingSystemValue === ''" class="pl-3">arrow_drop_down</v-icon>
            <v-icon text icon @click.stop="clearFilter('operatingSystem')" v-show="operatingSystemValue !== ''" class="pl-3">
              close
            </v-icon>
          </v-chip>
        </template>
        <v-card>
          <v-list class="pt-0 pb-0">
            <v-list-item class="pl-5 pr-2">
              <v-list-item-content class="pt-0 pb-0" style="margin-top: -8px;">
                <v-list-item-title><span style="font-weight: bold;">Operating System</span></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-1">
                <v-btn
                  icon
                  @click="menuClose('operatingSystem')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list class="pt-0 pb-0" style="margin-top: -12px;">
            <v-list-item>
              <v-radio-group v-model="operatingSystemValue" :mandatory="false" class="mt-0">
                <v-radio
                  v-for="device in deviceOperatingSystemSelectData"
                  :key="device.value"
                  :label="`${device.label}`"
                  :value="device.value"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-col>

    <v-col cols="auto" align-self="center" v-if="isFilterApplied()">
      <v-btn text @click="clearAll" style="color: #1D428A; text-transform: none;">Clear all</v-btn>
    </v-col>
  </v-row>
</template>

<script>
  import {mapActions, mapState, mapGetters} from "vuex";
  import {FILTER_DESCRIPTIONS} from '../constants';

  export default {
    name: "DevicesGlobalFilter",
    data() {
      return {
        radiosFormFactor: '',
        radiosAge: '',
        radiosUsage: '',
        radiosWarranty: '',
        radiosBuildNumber: '',
        radiosOperatingSystem: '',
        radiosModel: '',
        menuFormFactor: false,
        menuAge: false,
        menuUsage: false,
        menuWarranty: false,
        menuBuildNumber: false,
        menuOperatingSystem: false,
        menuModel: false,
      }
    },
    methods: {
      ...mapActions(['clearAllFilters', 'setFilter', 'clearFilter']),
      isNoData (name) {
            let data = [];
            switch (name) {
                case 'formfactor':
                    data = this.deviceFormFactorSelectData;
                    break;
                case 'age':
                    data = this.deviceAgeSelectData;
                    break;
                case 'utilisation':
                    data = this.deviceUtilisationSelectData;
                    break;
                case 'warranty':
                    data = this.deviceWarrantySelectData;
                    break;
                case 'buildNumber':
                    data = this.deviceBuildNumberSelectData;
                    break;
                case 'operatingSystem':
                    data = this.deviceOperatingSystemSelectData;
                    break;
                case 'model':
                    data = this.deviceModelSelectData;
                    break;
                default:
                    break;
            }
            return !(Array.isArray(data) && data.length > 0);
        },
      menuClose(name) {
          switch (name) {
              case 'formfactor':
                  this.menuFormFactor = false;
                  break;
              case 'model':
                  this.menuModel = false;
                  break;
              case 'age':
                  this.menuAge = false;
                  break;
              case 'utilisation':
                  this.menuUsage = false;
                  break;
              case 'warranty':
                  this.menuWarranty = false;
                  break;
              case 'buildNumber':
                  this.menuBuildNumber = false;
                  break;
              case 'operatingSystem':
                  this.menuOperatingSystem = false;
                  break;
              default:
                  break;
          }
      },
      clearAll() {
        this.radiosFormFactor = '';
        this.radiosAge = '';
        this.radiosUsage = '';
        this.radiosWarranty = '';
        this.radiosBuildNumber = '';
        this.radiosModel = '';
        this.clearAllFilters();
      },
      getAgeLabel(value) {
        return FILTER_DESCRIPTIONS['age'][value];
      },
      getUtilisationLabel(value) {
        return FILTER_DESCRIPTIONS['utilisation'][value];
      },
      getWarrantyLabel(value) {
        return FILTER_DESCRIPTIONS['warranty'][value];
      },
      sendEventToGA(actionName, value) {
        this.$ga.event({
          eventCategory: 'Planning Dashboard',
          eventAction: `${actionName}`,
          eventLabel: `${value}`
        });
      },
      isFilterApplied() {
         if (this.filters) {
             if (this.filters.age !== "" ||
                 this.filters.buildNumber !== "" ||
                 this.filters.formfactor !== "" ||
                 this.filters.model !== "" ||
                 this.filters.operatingSystem !== "" ||
                 this.filters.utilisation !== "" ||
                 this.filters.warranty !== ""
             ) {
                return true;
             }
         }
         return false;
      }
    },
    computed: {
      ...mapState({
        school: state => state.school.selected,
        filters: state => state.api.filters,
      }),
      ...mapGetters([
        'deviceFormFactorSelectData',
        'deviceAgeSelectData',
        'deviceUtilisationSelectData',
        'deviceWarrantySelectData',
        'deviceBuildNumberSelectData',
        'deviceOperatingSystemSelectData',
        'deviceModelSelectData',
        'deviceFormFactorFilter',
        'deviceAgeFilter',
        'deviceUtilisationFilter',
        'deviceWarrantyFilter',
        'deviceBuildNumberFilter',
        'deviceOperatingSystemFilter',
        'deviceModelFilter'
      ]),
      formFactorValue: {
        get () {
          return this.deviceFormFactorFilter ? this.deviceFormFactorFilter : '';
        },
        set (val) {
          this.radiosFormFactor = val;
        }
      },
      ageValue: {
        get () {
          return this.deviceAgeFilter ? this.deviceAgeFilter : '';
        },
        set (val) {
          this.radiosAge = val;
        }
      },
      usageValue: {
        get () {
          return this.deviceUtilisationFilter ? this.deviceUtilisationFilter : '';
        },
        set (val) {
          this.radiosUsage = val;
        }
      },
      warrantyValue: {
        get () {
          return this.deviceWarrantyFilter ? this.deviceWarrantyFilter : '';
        },
        set (val) {
          this.radiosWarranty = val;
        }
      },
      buildNumberValue: {
        get () {
          return this.deviceBuildNumberFilter ? this.deviceBuildNumberFilter : '';
        },
        set (val) {
          this.radiosBuildNumber = val;
        }
      },
      operatingSystemValue: {
        get () {
          return this.deviceOperatingSystemFilter ? this.deviceOperatingSystemFilter : '';
        },
        set (val) {
          this.radiosOperatingSystem = val;
        }
      },
      modelValue: {
        get () {
          return this.deviceModelFilter ? this.deviceModelFilter : '';
        },
        set (val) {
          this.radiosModel = val;
        }
      },
    },
    watch: {
      radiosFormFactor: function (value) {
        if (value !== '') {
          this.sendEventToGA('formfactor filter',value);
          this.setFilter({field: "formfactor", value: value});
        }
      },
      radiosAge: function (value) {
        if (value !== '') {
          this.sendEventToGA('age filter',value);
          this.setFilter({field: "age", value: value});
        }
      },
      radiosUsage: function (value) {
        if (value !== '') {
          this.sendEventToGA('utilisation filter',value);
          this.setFilter({field: "utilisation", value: value});
        }
      },
      radiosWarranty: function (value) {
        if (value !== '') {
          this.sendEventToGA('warranty filter',value);
          this.setFilter({field: "warranty", value: value});
        }
      },
      radiosBuildNumber: function (value) {
        if (value !== '') {
          this.sendEventToGA('buildNumber filter',value);
          this.setFilter({field: "buildNumber", value: value});
        }
      },
      radiosOperatingSystem: function (value) {
        if (value !== '') {
          this.sendEventToGA('operatingSystem filter',value);
          this.setFilter({field: "operatingSystem", value: value});
        }
      },
      radiosModel: function (value) {
        if (value !== '') {
          this.sendEventToGA('model filter',value);
          this.setFilter({field: "model", value: value});
        }
      },
      filters: {
        handler: function (value) {
          if (value.formfactor === '') {
            this.radiosFormFactor = '';
          }

          if (value.age === '') {
            this.radiosAge = '';
          }

          if (value.formfactor === '') {
            this.radiosFormFactor = '';
          }

          if (value.utilisation === '') {
            this.radiosUsage = '';
          }

          if (value.warranty === '') {
            this.radiosWarranty = '';
          }

          if (value.buildNumber === '') {
            this.radiosBuildNumber = '';
          }

          if (value.operatingSystem === '') {
            this.radiosOperatingSystem = '';
          }

          if (value.model === '') {
            this.radiosModel = '';
          }
        },
        deep: true,
      },
    },
  }
</script>

<style scoped>
</style>
